import React, { useRef, useState } from 'react';
import MountainForm from './MountainForm';
import MyButton from '../components/MyButton';
import ErrorSection from '../components/ErrorSection';
import RowColLayout from '../components/RowColLayout';

const MainMountain = ({
  token,
  flow,
  FlowParticipantId,
  inviteeParticipantId,
  mainNeedsMountain,
  inviteeNeedsMountain,
  genderMainParticipant,
  genderInvitee,
  onSubmitted,
  onSkip
}) => {
  const mainFormRef = useRef();
  const inviteeFormRef = useRef();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmitAll = async () => {
    setError(null);
    setLoading(true);

    try {
      let mainResponse, inviteeResponse;

      if (mainNeedsMountain && mainFormRef.current) {
        mainResponse = await mainFormRef.current.submit(); // Assuming submit returns a response
        console.log("Main Mountain Form Submission Response:", mainResponse);
      }

      if (inviteeNeedsMountain && inviteeFormRef.current) {
        inviteeResponse = await inviteeFormRef.current.submit(); // Assuming submit returns a response
        console.log("Invitee MOUNTAIN Form Submission Response:", inviteeResponse);
      }

      onSubmitted?.();
    } catch (err) {
      setError(err.message || 'Error enviando información de montaña');
    } finally {
      setLoading(false);
    }
  };

  console.log("Inside Main Mountain:");
  console.log("Main Participant:", FlowParticipantId);
  console.log("Invitee:", inviteeParticipantId);

  return (
    <section>
      <RowColLayout>
        <h3>Información para tu equipo de Esquí/Snowboard</h3>
        <p>Danos tus medidas para tener todo listo a tu llegada.</p>
      </RowColLayout>

      <RowColLayout>
        {mainNeedsMountain && (
          <MountainForm
            ref={mainFormRef}
            token={token}
            participantId={FlowParticipantId}
            gender={genderMainParticipant}
          />
        )}
      </RowColLayout>

      {flow === 'double' && (
        <RowColLayout>
          {inviteeNeedsMountain && (
            <MountainForm
              ref={inviteeFormRef}
              token={token}
              participantId={inviteeParticipantId}
              gender={genderInvitee}
            />
          )}
        </RowColLayout>
      )}

      <RowColLayout>
        <MyButton text={"Continuar"} onClick={handleSubmitAll} disabled={loading} />
      </RowColLayout>

      <ErrorSection error={error} />
    </section>
  );
};

export default MainMountain;
